import { render } from "./ServerTime.vue?vue&type=template&id=437fdee0"
import script from "./ServerTime.vue?vue&type=script&lang=js"
export * from "./ServerTime.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ServerTime.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "437fdee0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('437fdee0', __exports__)) {
    api.reload('437fdee0', __exports__)
  }
  
  module.hot.accept("./ServerTime.vue?vue&type=template&id=437fdee0", () => {
    api.rerender('437fdee0', render)
  })

}


export default __exports__